import React from "react";
import { Link } from "react-router-dom";

const ExtraError = (props) => {
    return (
        <div className="error">
            <div className="error-code">404</div>
            <div className="error-content">
                <div className="error-message">No se puede acceder a esta direccion...</div>
                <div className="error-desc mb-4">
                    La pagina que estas intentando acceder no existe. <br />
                </div>
                <div>
                    <Link to="/dashboard" className="btn btn-success px-3">
                        Ir a Dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ExtraError;
